var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pre-example-wrapper"},[_c('h3',{staticClass:"title"},[_c('img',{attrs:{"src":require('@/assets/img/icon_info_circle.png'),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"arrow"}),_c('img',{attrs:{"src":_vm.url,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }